module.exports = __webpack_public_path__ + "static/media/uncharted-image.12074315.png";